import React from 'react';
import useAsyncDataCourier from '../../common/custom-hooks/useAsyncDataCourier';
import MessageCourier from '../../lib/MessageCourier';
import { OficialMesa } from '../../system/OficialMesa/OficialMesa';
import SystemClient from '../../system/SystemClient';
import ComboBoxSearch, { IComboBoxSearch } from '../Common/ComboBoxSearch';
import { IComboBoxOption } from '@fluentui/react';
import ComboBoxInput from '../../lib/FormValidator/Form/ComboBoxInput';
import CustomInputIfc from '../../lib/FormValidator/Form/CustomInputIfc';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import useForceUpdate from '../../common/custom-hooks/useForceUpdate';
interface IOficialMesaSelector {
  system: SystemClient;
  courier: MessageCourier;
  comboboxParams: IComboBoxSearch;
  providedList?: OficialMesa[];
}

export const OficialMesaSelector = (props: IOficialMesaSelector) => {
  // const oficialMesas = useAsyncDataCourier(
  //   () => props.system.getOficialMesaSystem().getListForDropdown(),
  //   [],
  //   props.courier
  // );
  const oficialMesas = useAsyncDataCourier(
    () =>
      props.providedList
        ? Promise.resolve(props.providedList)
        : props.system.getOficialMesaSystem().getListForDropdown(),
    [props.providedList],
    props.courier
  );
  const oficialMesaOptions = React.useMemo(() => {
    let ret: IComboBoxOption[] = [];
    if (oficialMesas) {
      oficialMesas.map((entity: OficialMesa) => {
        return { key: entity.getId()!, text: String(entity.getId()!), data: entity };
      });
    }

    return ret;
  }, [oficialMesas]);
  return <ComboBoxSearch {...props.comboboxParams} options={oficialMesaOptions}></ComboBoxSearch>;
};

interface IOficialMesaSelectorInput {
  system: SystemClient;
  courier: MessageCourier;
  input: CustomInputIfc;
  hideLabel?: boolean;
  onBlurCustomInput: (customInput: CustomInputIfc) => void;
  providedList?: OficialMesa[];
  disabled?: boolean;
  onDelete?: () => void;
}

export const OficialMesaSelectorInput = (props: IOficialMesaSelectorInput) => {
  const { t, i18n } = useTranslation();
  const [currentOficialMesa, setCurrentOficialMesa] = React.useState<OficialMesa | undefined>(undefined);
  const [oficialMesaOptions, setOficialMesaOptions] = React.useState<IComboBoxOption[]>([]);
  const oficialMesas = useAsyncDataCourier(
    () =>
      props.providedList
        ? Promise.resolve(props.providedList)
        : props.system.getOficialMesaSystem().getListForDropdown(),
    [props.providedList],
    props.courier
  );
  const mapOficialMesaOptions = (oficialMesas: OficialMesa[]) => {
    const opciones = oficialMesas.map((entity: OficialMesa) => {
      return { key: entity.getId()!, text: `${entity.getNombre()} ${entity.getApellido()}`, data: entity };
    });
    setOficialMesaOptions(opciones);
  };
  const selectDefaultOficialMesa = (id: string) => {
    setCurrentOficialMesa(
      oficialMesas ? oficialMesas.find((entity: OficialMesa) => entity.getId() === id) : undefined
    );
  };
  const forceUpdate = useForceUpdate();
  const getLabelFromOficialMesa = (entity: OficialMesa) => {
    const label = String(entity.getId()!);
    return label;
  };

  React.useEffect(() => {
    forceUpdate();
  }, [currentOficialMesa]);
  React.useEffect(() => {
    selectDefaultOficialMesa(props.input.getValue());
    mapOficialMesaOptions(oficialMesas ? oficialMesas : []);
  }, [oficialMesas, currentOficialMesa]);
  const getStartingSelectionOficialMesa = () => {
    let ret = '';
    if (oficialMesas) {
      const _entity = oficialMesas.find((e: OficialMesa) => e.getId() === props.input.getValue());
      if (_entity) ret = getLabelFromOficialMesa(_entity);
    }

    return ret;
  };
  return (
    <>
      {oficialMesas && (
        <ComboBoxInput
          input={props.input}
          label={props.hideLabel ? '' : t('OficialMesa')}
          onBlur={props.onBlurCustomInput}
          options={oficialMesaOptions ? oficialMesaOptions : []}
          selectedKey={getStartingSelectionOficialMesa()}
          disabled={props.disabled}
          onDelete={props.onDelete}
        />
      )}
    </>
  );
};
